import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocalParticipant, useDevices, useDaily } from '@daily-co/daily-react';
import { pageAtom, topMessageAtom } from '../../State';
import { useSetRecoilState } from 'recoil';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeWhiteButton.svg';
import DataModel from '../Util/DataModel';
import { ReactComponent as FacelessBoySVG } from '../Images/buttons/electronTopBottom.svg';
import { getAuth, sendSignInLinkToEmail, signInWithCustomToken } from 'firebase/auth';
import NFT from '../NFT/NFT';
import Live2dWrap from '../Live2d/Live2dWrap';
import Header from '../Header/Header';
import isElectron from '../../Global';

export default function BrowserFace({ setShowJoin }) {
  //レンダー
  return (
    <>
      <div className={'appElectron'}>
        <div id="headerBlack"></div>
        <Header url={'dd'} isHairCheck={true} showSettingButton={false} />
        <NFT isFaceScreen={true} />
        <div className="call">
          <Live2dWrap isHairCheck={true} isFaceScreen={true} />
        </div>
      </div>
    </>
  );
}
